export default {
  //代码里的key(唯一标识): '西班牙语',
  lang: 'es',
  appIntroduction: 'Vea gratis y en cualquier momento las Películas y Series más populares',
  noMoreTip: 'Ya ha llegado al final, no hay más contenidos~',
  navigator: {
    home: 'Página de inicio',
    all: 'Todo',
    news: 'Noticias',
    download: 'Descargar',
    contact: 'Sobre nosotros',
    joinUs: 'Únete a nosotros'
  },
  seo: {
    title: 'Loklok Watch HD movies online for free',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie, ver en línea,ver gratis, ver doramas gratis, new movies,tv show,Snowdrop,Hotel Transylvania,Encanto,The Silent Sea,Jujutsu Kaisen,9-1-1: Lone Star,Hotel Transylvania,Dragons,SnowdropOur Beloved SummerDemon SlayerHappinessSing 2Ranking of KingsDemon SlayerAttack on TitanTrue BeautyVincenzoAttack on Titan The Final SeasonJujutsu KaisenThe HandmaidenTokyo RevengersNeverthelessItaewon ClassSquid GameCrash Landing on YouEuphoriaAttack on TitanHometown Cha-Cha-Cha',
    description: 'Popular episodes updated quickly,American hot series,Tension, comedy, thriller,Newest hottest dramasall in Loklok',
    ogImage: 'https://static.loklok.video/img/tw-en.png',
    index: {
      title: 'Loklok Mira películas HD en línea gratis',
      keywords: 'Loklok, Loklok app, descarga loklok, loklok pc, loklok apk, loklok ios, loklok android, loklok para ios,ver en línea,ver gratis, ver doramas gratis, loklok para android, loklok android tv, loklok chromecast, kdrama, k-drama, drama coreano, taquilla, cines de los Estados Unidos, cines de occidente, blockbuster películas, cines de Tailandia, thai películas, telenovela, series, anime, animación, dibujos animados, reality show, yaoi, yuri, bl, gl, hollywood, bollywood, zombie, one piece, naruto, relaciones ilícitas, Estamos muertos',
      description: 'Loklok global HD video ver en línea de forma gratuita. Tiene muchos episodios populares, películas populares de alta definición y subtítulos en varios idiomas.'
    },
    allPage: {
      title: 'Loklok Mira películas HD en línea gratis, cualquier cosa que puedas imaginar.',
      keywords: 'Loklok, Loklok app, descargar loklok, loklok pc, loklok apk, ver en línea,ver gratis, ver doramas gratis, animación,anime,blockbuster películas,episodio nuevo,estreno de películas, 2022 últimas agregadas,premiere,sci-fi, romancia dulce,comedia,acctión,amore, plículas gratis, plículas gratis app , Estamos muertos, F4 Thailand: Boys Over Flowers, Euphoria Temporada 2, Veinticinco, veintiuno, Las inclemencias del amor,Ghost Doctor, True Beauty,Encanto, From,Business Proposal,Snowdrop,Rookie Cops,Still 2gether',
      description: 'Loklok tiene toneladas de películas y contenido de TV populares, ¡las últimas y mejores series de TV y películas se pueden ver gratis!'
    },
    articles: {
      title: 'Loklok Mira películas HD en línea gratis, últimas noticias',
      keywords: 'Loklok, Loklok app, descargar loklok, loklok pc, loklok apk, ver en línea,ver gratis, ver doramas gratis,información más reciente sobre películas y televisión, recomendaciones de películas, reseñas de películas populares, películas y televisión de 2022, estreno de películas, lo que vale la pena ver en 2022, tener que ver en 2022, películas de cine en 2022, próximas películas de 2023 , Peaky Blinders Temporada 6, Attack on Titan temporada final, Aquel año nuestro, hotel transylvania 4: transformania, felicidad',
      description: 'Búsqueda instantánea de contenido de películas y series de TV populares de Loklok, películas populares, reseñas de películas de series de TV populares'
    },
    download: {
      title: 'Descarga de la última versión oficial de la aplicación Loklok',
      keywords: 'Loklok, Loklok app, descargar loklok, loklok pc, loklok apk,ver en línea,ver gratis, ver doramas gratis, loklok descarga, descarga loklok,  descarga loklok apk, descarga loklok ios, descarga loklok android, loklok googleplay, descarga loklok pc , loklok última versión, loklok official página, como descargar Loklok, Loklok desktop, Loklok pad',
      description: 'Descargue la aplicación Loklok y vea películas y programas de TV populares en línea en cualquier momento. Escanee el código QR para ver al mismo tiempo en la PC.'
    },
    search: {
      title: 'Loklok - Encontrar Tus Películas Favoritas',
      keywords: 'Loklok, Loklok app, descargar loklok, loklok pc, loklok apk,ver en línea,ver gratis, ver doramas gratis, buscar dramas, buscar episodios, listas de películas populares, listas de taquilla, listas de películas, listas de series, ranking de películas, ranking de dramas coreanos, ranking de dramas tailandeses, Top 10 películas, Top 10 dramas, Top 100 películas de 2022, Top 100 películas de 2021, Top 100 películas más esperadas de 2022 , películas más vistas en 2022, las mejores películas de 2021, All of Us Are Dead, The Pirates: The Last Royal Treasure, Euphoria, True Beauty, Encanto, F4 Thailand: Boys Over Flowers, Rookie Cops, Spider-Man: No Way Home, Euphoria Season 2, Ghost Doctor',
      description: 'Loklok recomienda los dramas, películas, etc. más populares a nivel mundial de acuerdo con la popularidad de vista y búsqueda diaria en tiempo real para resolver la escasez de dramas y mejorar la experiencia de visualización.'
    },
    contact: {
      title: 'Contáctenos por correo electrónico, Twitter, Facebook, Instagram y Youtube. - Loklok',
      keywords: 'Twitter, Facebook, Instagram, ver en línea,ver gratis, ver doramas gratis,Youtube, Contact, E-mail',
      description: 'Las preguntas sobre loklok se pueden comunicar por correo electrónico, Twitter, Facebook, Instagram y Youtube.'
    }
  },
  globalTip: {
    emptyTip: 'Aquí no hay nada de nada',
    searchOther: 'Intenta buscar otras películas o series'
  },
  loginModule: {
    title: 'Iniciar sesión',
    loginMethod: 'Use la aplicación loklok para escanear el código QR',
    loginMethodTip: '(debe actualizar a la versión 1.7.0 o superior)',
    howToDownload: 'Cómo descargar loklok',
    clickMe: 'Púlsame',
    loginSuccess: 'Sesión iniciada',
    loginFailed: 'Inicio de sesión fallido',
    codeExpired: 'El código QR ha expirado',
    refreshButton: 'Refrescar',
    loginButton: 'Iniciar sesión',
    loginTip: 'Vea gratis todo el contenido del sitio después de iniciar sesión',
    logoutButton: 'Cerrar sesión',
    logoutTip: '¡Disfrute del visionado!',
    areYouSure: '¿Seguro que quiere cerrar la sesión?',
    sure: 'Confirmar',
    cancel: 'Cancelar'
  },
  toTop: {
    downloadApp: 'Descargar aplicación',
    backToTop: 'Volver arriba'
  },
  indexPage: {
    title: 'LoklokTV',
    more: 'Más',
    seeMore: 'Ver más'
  },
  searchPage: {
    resultTitle: 'Resultados de la búsqueda:',
    rank: 'Más popular de Loklok',
    play: 'Emitir',
    popularSearch: 'Búsquedas populares',
    top1: 'Top 1',
    top2: 'Top 2',
    top3: 'Top 3',
    top4: 'Top 4',
    top5: 'Top 5',
    top6: 'Top 6',
    top7: 'Top 7',
    top8: 'Top 8',
    top9: 'Top 9',
    top10: 'Top 10',
    emptyTip: 'Lo sentimos: no tenemos ese contenido',
    emptyDesc: 'Pruebe a ver otra película o serie'
  },
  filterPage: {
    emptyTip: 'Lo sentimos: no tenemos ese contenido',
    emptyDesc: 'Pruebe a ver otra película o serie'
  },
  newsPage: {
    listTitle: 'Noticias recientes'
  },
  downloadPage: {
    scanQR: 'Escanee código QR para descargar aplicación',
    title1: 'Películas y dramas populares',
    tip1: 'Verlo en cualquier momento gratis',
    title2: 'Subtítulos multilingües',
    tip2: 'Ver drama fácilmente',
    title3: 'Sincronización PC/Teléfono en tiempo real'
  },
  detailPage: {
    autoTranslation: 'Traducción automática',
    fiveMiniteTip: 'Solo 5 minutos, ver la película completa después',
    loginTip2InDetailPage: 'Use la aplicación loklok para escanear el siguiente código QR, y vea el resto del contenido después de iniciar sesión',
    category: 'Categoría',
    moreDesc: 'Más',
    youMayLike: 'Te podría gustar',
    relatedSeries: 'Series relacionadas',
    norelatedSeries: 'No hay series relacionadas',
    emptyDesc: 'Lo sentimos: no tenemos ese contenido',
    emptyTip: 'Lo sentimos: no tenemos ese contenido',
    vip: {
      dialog: {
        t1: 'Activar VIP',
        t2: 'Activa VIP en la app para ver el contenido completo',
        t3: 'Descargue la aplicación a través del método a continuación',
        t4: '¿Ya tienes VIP? <span class="active">Haga clic aquí</span> para ingresar',
        t5: '¿Ya tienes VIP? Por favor <span class="active">actualice</span> y continúe viendolo',
        t6: 'Ha visto {num} minutos, para ver la versión completa, use la aplicación o active VIP en la aplicación para continuar viendo esta película'
      },
      player: {
        tip1: 'Solo puedes mirar durante {num} minutos. Puede s<span class="active">usar la aplicación</span> o <span class="active">activar VIP</span> para ver el video completo.'
      },
      episodes: {
        tip1: 'Obtenga VIP y vea la versión completa'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'El navegador está descargando datos',
    NETWORK_NO_SOURCE: 'No se ha encontrado la fuente de audio/vídeo',
    MEDIA_ERR_ABORTED: 'El proceso de recuperación ha sido abortado por el usuario',
    MEDIA_ERR_NETWORK: 'Ha ocurrido un error al descargar',
    MEDIA_ERR_DECODE: 'Ha habido un problema al resolver la reproducción: el archivo no puede reproducirse',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Formato de audio/vídeo no soportado',
    REPLAY: 'Volver a reproducir',
    ERROR: 'Parece que hay un problema con la conexión de red',
    PLAY_TIPS: 'Emitir',
    PAUSE_TIPS: 'Pausar',
    PLAYNEXT_TIPS: 'Siguiente episodio',
    DOWNLOAD_TIPS: 'Descargar',
    ROTATE_TIPS: 'Rotar',
    RELOAD_TIPS: 'Volver a cargar',
    FULLSCREEN_TIPS: '进入全屏',
    EXITFULLSCREEN_TIPS: 'Salir de la pantalla completa',
    CSSFULLSCREEN_TIPS: 'Entrar en el modo de pantalla completa',
    EXITCSSFULLSCREEN_TIPS: 'Salir del modo de pantalla completa',
    TEXTTRACK: 'Subtítulos',
    PIP: 'Imagen superpuesta',
    MINIPLAYER: 'Minirreproductor',
    SCREENSHOT: 'Captura de pantalla',
    LIVE: 'Retransmitiendo en vivo',
    OFF: 'Cerrar',
    MINIPLAYER_DRAG: 'Mantenga pulsado para arrastrar el vídeo',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'Solo se reproducirán {msg} minutos, inicie sesión para verlo entero',
    loginTextButton: 'Iniciar sesión',
    replayButton: 'Volver a reproducir',
    nextButton: 'Siguiente episodio',
    refreshButton: 'Refrescar',
    episode: 'Episodio',
    onlyPlayTextBtn: 'log in'
  },
  contact: {
    business: 'Cooperación empresarial',
    question: 'Preguntas y comentarios'
  },
  download_nd: {
    desc: 'Ver un gran número de películas y series gratis',
    scanQR: 'Escanee el código QR para descargar la aplicación o'
  },
  win: {
    feedback: {
      que: 'Explicación de Preguntas Frecuentes',
      que1: 'Preguntas Frecuentes',
      content: 'Contenido de la Retroalimentación',
      contact: ' Información de Contacto',
      submit: 'Enviar comentarios',
      tip1: ' Por favor, proporcione una descripción detallada y también puede incluir capturas de pantalla relevantes.',
      tip2: 'Por favor, introduzca su correo electrónico.',
      tip5: 'El tamaño de la imagen cargada debe ser menor de {num}k.',
      tip6: 'Se pueden cargar un máximo de 4 imágenes.',
      tip3: 'Enviado, por favor, tenga paciencia.',
      tip4: 'El contenido de la retroalimentación debe tener al menos 10 palabras.',
      error: 'Error del Sistema'
    }
  },
  tv: {
    vip: {
      title: 'Por favor, seleccione su producto',
      tip1: 'Después de iniciar sesión, puedes ver el código QR de pago.',
      refresh: 'Actualizar',
      tip2: 'Escanea el código QR para el pago',
      recharge: 'Acuerdo de Recarga',
      renewal: 'Acuerdo de Renovación',
      login: 'Inicia sesión ahora',
      tip3: 'Ver después de iniciar sesión',
      noOpen: 'VIP Estándar No Activado',
      gift: 'Regalo',
      succ: 'Actualización exitosa',
      fail: 'Actualización fallida',
      day: 'VIP estándar 1 día',
      days: 'VIP estándar {x} días',
      expiration: 'Tiempo de expiración VIP estándar: {x}',
      expired: 'Su VIP ha expirado, por favor, renueve con prontitud.',
      interests1: ' Disfruta de la calidad HD 1080P',
      interests2: 'Desbloquea todo el contenido',
      interests3: ' Inicio de sesión en múltiples dispositivos'
    }
  }
}